import React from 'react';

import { CompareCheckbox } from '../compare-checkbox';
import { ProductMedia } from '../media';

import { ImageWrapper, BrandLogo } from './styles';

import type { BaseProps } from '../../types';

type Props = Pick<
  BaseProps,
  | 'selectable'
  | 'selected'
  | 'imageSrc'
  | 'imageSize'
  | 'shouldLazyLoadImage'
  | 'brand'
  | 'name'
>;

export const ListCardMedia: React.FC<Props> = props => {
  const {
    name,
    selectable,
    selected = false,
    imageSrc,
    imageSize = 100,
    shouldLazyLoadImage,
    brand,
  } = props;

  return (
    <>
      {selectable ? <CompareCheckbox selected={selected} /> : null}

      <ImageWrapper $size={`${imageSize}px`}>
        {brand?.logo && <BrandLogo src={brand.logo} alt={brand.name || ''} />}

        <ProductMedia
          imageSrc={imageSrc}
          imageSize={imageSize}
          name={name || ''}
          lazyLoadImage={shouldLazyLoadImage || false}
        />
      </ImageWrapper>
    </>
  );
};
